import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import browserStorage from "services/storage/browserStorage";

const token = browserStorage.get("token");

const config: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 15000,
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

axios.interceptors.request.use(
  (config) => {
    const token = browserStorage.get("token");
    return {
      ...config,
      baseURL: process.env.REACT_APP_PRODUCTION_URL,
      // So'rovda aniq timeout berilgan bo'lsa — o'shani hurmat qilamiz
      // (arxivlash kabi uzoq amallar uchun kerak), aks holda default 31s
      timeout: config.timeout || 31000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const axiosInstance: AxiosInstance = axios.create(config);

export default axios;
